import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { DomainRegistrar, DomainRegistrarFormFields, DomainRegistrarsQueryKeys } from '@/modules/DomainRegistrars';

export const useGetAllDomainRegistrarsQuery = (paginationOptions: AppPaginationOptions, search?: string) =>
  buildQuery<WithPagination<DomainRegistrar>, QueryError>(
    [DomainRegistrarsQueryKeys.GetAll, { ...paginationOptions, search }],
    async () => {
      const { data } = await apiExecutor.get<WithPagination<DomainRegistrar>>(ApiRoutes.DomainRegistrars, {
        params: { ...paginationOptions, search }
      });

      return data;
    }
  );

export const useGetOneByIdDomainRegistrarsQuery = (domainRegistrarId: string) =>
  buildQuery<DomainRegistrar, QueryError>([DomainRegistrarsQueryKeys.GetOneById, domainRegistrarId], async () => {
    const { data } = await apiExecutor.get<DomainRegistrar>(
      ApiRoutes.DomainRegistrarsById.replace(':domainRegistrarId', domainRegistrarId)
    );
    return data;
  });

export const useCreateDomainRegistrarsMutation = () =>
  buildMutation<DomainRegistrar, QueryError, DomainRegistrarFormFields>(
    [DomainRegistrarsQueryKeys.Create],
    async (postData: DomainRegistrarFormFields) => {
      const { data } = await apiExecutor.post<DomainRegistrar>(ApiRoutes.DomainRegistrars, {
        ...postData
      });
      return data;
    }
  );

export const useDeleteDomainRegistrarsMutation = (domainRegistrarId: string) =>
  buildMutation<void, QueryError, void>([DomainRegistrarsQueryKeys.Delete, domainRegistrarId], async () => {
    await apiExecutor.delete<void>(ApiRoutes.DomainRegistrarsById.replace(':domainRegistrarId', domainRegistrarId));
  });

export const useAutocompleteDomainRegistrarQuery = (params: { query: string; includedIds?: string[]; }) =>
  buildQuery<Pick<DomainRegistrar, 'id' | 'name'>[], QueryError>(
    [DomainRegistrarsQueryKeys.Autocomplete, params],
    async () => {
      const { data } = await apiExecutor.get<Pick<DomainRegistrar, 'id' | 'name'>[]>(
        ApiRoutes.DomainRegistrarsAutocomplete,
        { params: { q: params.query, includedIds: params?.includedIds?.length ? String(params.includedIds) : undefined, } }
      );
      return data;
    }
  );

export const useBreadcrumbDomainRegistrarQuery = (domainRegistrarId: string) =>
  buildQuery<string, QueryError>([DomainRegistrarsQueryKeys.Breadcrumb], async () => {
    const { data } = await apiExecutor.get<string>(
      ApiRoutes.DomainRegistrarsBreadcrumb.replace(':domainRegistrarId', domainRegistrarId)
    );
    return data;
  });
